import React from 'react'
import styled from 'styled-components'
import Label from './Label'

const FloorNumberContainer = styled.div`
  font-size: 30px;
  font-weight: bold;
  color: ${props => (props.selected ? '#ffffff' : '#ffffff')};
  box-sizing: border-box;
  position: relative;

  @media (max-width: 420px) {
    font-size: 20px;
    text-align: center;
  }
`

const FloorNumber = props => {
  return (
    <FloorNumberContainer data-testid="floor-number-container" selected={props.selected}>
      {props.value}
      <Label label={props.label} selected={props.selected} />
    </FloorNumberContainer>
  )
}

export default FloorNumber
